import { Injectable } from '@angular/core';
import { MessageTypeEnum } from '@app/ngrx-message/constants/messageTypeEnum';
import { Message } from '@app/ngrx-message/models/client/message';
import { MessageStoreService } from '@app/ngrx-message/services/message/message-store.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { RECIPE_ACTIONS } from '@usf/ngrx-tools';
import { tap } from 'rxjs';
import { MppService } from '../service/mpp.service';

@Injectable({
  providedIn: 'root',
})
export class ClientMppEffects {
  archiveRecipeSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(RECIPE_ACTIONS.archiveRecipesSuccess),
        tap(action => {
          this.displayToastMessage(
            MessageTypeEnum.success,
            this.translateService.instant(
              action?.archiveRecipe?.isArchive
                ? 'i18n.menuProfitPro.message.archiveSuccess'
                : 'i18n.menuProfitPro.message.unarchiveSuccess',
            ),
          );
        }),
      ),
    { dispatch: false },
  );

  archiveRecipeFail$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(RECIPE_ACTIONS.archiveRecipesFailure),
        tap(action => {
          this.displayToastMessage(
            MessageTypeEnum.error,
            this.translateService.instant(
              action?.archiveRecipe?.isArchive
                ? 'i18n.menuProfitPro.message.archiveFail'
                : 'i18n.menuProfitPro.message.unarchiveFail',
            ),
          );
        }),
      ),
    { dispatch: false },
  );

  createRecipeFail$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(RECIPE_ACTIONS.createRecipeFailure),
        tap(action => {
          this.displayToastMessage(
            MessageTypeEnum.error,
            this.translateService.instant(
              'i18n.menuProfitPro.message.createRecipeFail',
            ),
          );
        }),
      ),
    { dispatch: false },
  );

  createRecipeSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(RECIPE_ACTIONS.createRecipeSuccess),
        tap(action => {
          this.mppService.goToDetails(action.recipe.recipeId);
        }),
      ),
    { dispatch: false },
  );

  copyRecipeSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(RECIPE_ACTIONS.copyRecipeSuccess),
        tap(action => {
          this.displayToastMessage(
            MessageTypeEnum.success,
            this.translateService.instant(
              'i18n.menuProfitPro.copyModal.toast.success',
            ),
          );
        }),
      ),
    { dispatch: false },
  );

  copyRecipeFail$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(RECIPE_ACTIONS.copyRecipeFailure),
        tap(action => {
          this.displayToastMessage(
            MessageTypeEnum.error,
            this.translateService.instant(
              'i18n.menuProfitPro.copyModal.toast.error',
            ),
          );
        }),
      ),
    { dispatch: false },
  );

  uploadToS3Fail$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(RECIPE_ACTIONS.uploadRecipeProfileImageToS3Failure),
        tap(action => {
          this.displayToastMessage(
            MessageTypeEnum.error,
            this.translateService.instant(
              'i18n.menuProfitPro.uploadRecipeImageModal.toast.error',
            ),
          );
        }),
      ),
    { dispatch: false },
  );

  displayToastMessage(
    type: MessageTypeEnum,
    message: string,
    sticky = false,
  ): void {
    this.messageStoreService.upsertMessage({
      type,
      display: message,
      toast: true,
      sticky,
    } as Message);
  }

  constructor(
    private actions$: Actions,
    private translateService: TranslateService,
    private messageStoreService: MessageStoreService,
    public store: Store,
    private mppService: MppService,
  ) {}
}
